import {copyText} from "./progress"

function selectedMechs(root) {
  return Array.from(root.querySelectorAll("[data-learn-mech][aria-pressed='true']")).map((button) => button.dataset.learnMech)
}

function qualifier(root) {
  return root.querySelector("[data-learn-all][aria-pressed='true']")?.dataset.learnAll || "~all"
}

function recordFor(mechs, all) {
  return `v=spf1${mechs.length ? ` ${mechs.join(" ")}` : ""} ${all}`
}

function paintMeter(root, count) {
  const tone = count > 10 ? "bg-bad" : count >= 8 ? "bg-warn" : "bg-good"
  root.querySelectorAll("[data-learn-seg]").forEach((seg, index) => {
    seg.classList.remove("bg-good", "bg-warn", "bg-bad", "bg-surface-raised")
    seg.classList.add(index < Math.min(count, 10) ? tone : "bg-surface-raised")
  })
  const countEl = root.querySelector("[data-learn-lookups]")
  if (countEl) countEl.textContent = String(count)
  const warn = root.querySelector("[data-learn-lookup-note]")
  if (warn) warn.hidden = count <= 10
}

function render(root) {
  const mechs = selectedMechs(root)
  const all = qualifier(root)
  const record = recordFor(mechs, all)
  const output = root.querySelector("[data-learn-record]")
  if (output) output.textContent = record
  root.querySelectorAll("[data-learn-all-help]").forEach((help) => {
    help.hidden = help.dataset.learnAllHelp !== all
  })
  paintMeter(root, mechs.length)
}

export function mount(root) {
  const live = root.querySelector("[data-learn-copy-status]")
  root.querySelectorAll("[data-learn-mech]").forEach((button) => {
    button.addEventListener("click", () => {
      button.setAttribute("aria-pressed", String(button.getAttribute("aria-pressed") !== "true"))
      render(root)
    })
  })
  root.querySelectorAll("[data-learn-all]").forEach((button) => {
    button.addEventListener("click", () => {
      root.querySelectorAll("[data-learn-all]").forEach((other) => {
        other.setAttribute("aria-pressed", String(other === button))
      })
      render(root)
    })
  })
  root.querySelector("[data-learn-copy]")?.addEventListener("click", () => {
    copyText(root.querySelector("[data-learn-record]")?.textContent || "", live, "Copied.")
  })
  render(root)
}
